import React from "react";
import { Phone, MessageCircle, MessageSquare } from "lucide-react";
import { businessInfo } from "../data/mockData";
import { trackContactClick } from "../lib/analytics";

export const ContactButtons = ({ variant = "default", location = "hero", className = "" }) => {
  const base =
    "inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md font-semibold transition-all duration-200 text-sm sm:text-base whitespace-nowrap";
  const sizing = variant === "large" ? "px-6 py-4 text-base" : "";
  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      <a
        href={businessInfo.phoneTel}
        onClick={() => trackContactClick("call", location)}
        data-testid="cta-call-btn"
        className={`${base} ${sizing} bg-brand-navy text-white hover:bg-brand-navy-light shadow-md hover:shadow-lg`}
      >
        <Phone className="h-4 w-4" />
        Call Now
      </a>
      <a
        href={businessInfo.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackContactClick("whatsapp", location)}
        data-testid="cta-whatsapp-btn"
        className={`${base} ${sizing} bg-brand-whatsapp text-white hover:bg-brand-whatsapp-dark shadow-md hover:shadow-lg`}
      >
        <MessageCircle className="h-4 w-4" />
        WhatsApp Us
      </a>
      <a
        href={businessInfo.sms}
        onClick={() => trackContactClick("text", location)}
        data-testid="cta-text-btn"
        className={`${base} ${sizing} bg-brand-blue text-white hover:bg-brand-blue-light shadow-md hover:shadow-lg`}
      >
        <MessageSquare className="h-4 w-4" />
        Text Us
      </a>
    </div>
  );
};
